module.exports = __webpack_public_path__ + "img/122.744bc60e.svg";